namespace $ {
	export function $arch_alg_lzw64_decode( s: any ) {
		var dict: any = {}
		var data = ( s + "" ).split( "" )
		var currChar = data[ 0 ]
		var oldPhrase = currChar
		var out = [ currChar ]
		var code = 256
		var phrase
		for( var i = 1; i < data.length; i++ ) {
			var currCode = data[ i ].charCodeAt( 0 )
			if( currCode < 256 ) {
				phrase = data[ i ]
			}
			else {
				phrase = dict[ currCode ] ? dict[ currCode ] : ( oldPhrase + currChar )
			}
			out.push( phrase )
			currChar = phrase.charAt( 0 )
			dict[ code ] = oldPhrase + currChar
			code++
			oldPhrase = phrase
		}
		return out.join( "" )
	}
}

